import React from 'react'
import ReactDOM from 'react-dom'
import NoticeContainer from './NoticeContainer'
import { INoticeItemProps } from './NoticeItem'

export interface INoticeInstance {
  addNotice: (props: INoticeItemProps) => string;
  deleNotice: (id: string) => void;
}

export interface INoticeProps extends INoticeItemProps {}

let noticeContainerDiv = document.getElementById('noticeContainer') as HTMLElement
let noticeContainer: INoticeInstance

const getNoticeContainerRef = () => ReactDOM.render(<NoticeContainer />, noticeContainerDiv) as unknown as INoticeInstance

// 创建容器
const createNoticeWrapper = () => {
  if (!noticeContainerDiv) {
    noticeContainerDiv = document.createElement('div')
    noticeContainerDiv.setAttribute('id', 'noticeContainer')
    document.body.appendChild(noticeContainerDiv)
  }
  noticeContainer = getNoticeContainerRef()
}

// 显示
function noticeMessage<TProps extends INoticeItemProps> (
  props: TProps | string
) {
  let noticeProps = {} as TProps
  if (typeof props === 'string') {
    noticeProps.content = props
  } else {
    noticeProps = props
  }

  createNoticeWrapper()

  const noticeId = noticeContainer ? noticeContainer.addNotice(noticeProps) : ''
  return {
    dismiss: () => {
      noticeContainer.deleNotice(noticeId)
    },
  }
}

// 销毁
function destory () {
  noticeContainerDiv && ReactDOM.unmountComponentAtNode(noticeContainerDiv)
  noticeContainer = getNoticeContainerRef()
}

export default {
  noticeMessage,
  destory,
}
